<template>
    <div class="amine">
        <ul>
            <li>RNH<sub>2</sub></li>
            <li>-amin</li>
            <li>Amino-</li>
            <li>basisch</li>
            <li>funktionelle Gruppe mit freiem Elektronenpaar</li>
        </ul>
        <img
            src="@/assets/img/stoffe/amine/1-2-3-4.png"
            alt="Verschiedene Arten der Amine"
            title="Verschiedene Arten der Amine"
            width="100%"
        />
    </div>
</template>

<script>
export default {
    name: 'amine',
};
</script>
